// mobile-nav-categories

if (!customElements.get('mobile-nav-categories')) {
  class MobileNavCategories extends HTMLElement {
    abortController = null
    menuCache = {}
    currentMenuHandle = null

    constructor() {
      super()
    }

    connectedCallback() {
      this.urlPrefix =
        this.dataset.country === 'us' ? '' : `/${this.dataset.locale}-${this.dataset.country}`
      this.content = this.querySelector('.js-mobile-nav-content')
      this.weeklyDeal = this.dataset.weeklyDeal
      this.currentMenuHandle = this.getAttribute('data-menu-handle')
      this.weeklyDealEndDate = this.dataset.weeklyDealEndDate

      this.fetchAllMenus()
      this.initAccordions()
      this.closeMenuOnEscape()
    }

    closeMenuOnEscape() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const mobileNav = document.querySelector('#shopify-section-mobile-nav')
          if (!mobileNav) return
          const countryList = mobileNav.querySelector('.js-country-list')
          const countryListIsClosed = countryList.getAttribute('hidden') === 'true'
          if (mobileNav.classList.contains('active') && countryListIsClosed) {
            document.querySelector('#mobile-nav-close').click()
            document.querySelector('.main-nav__link[data-open-mobile-menu] a').focus()
          }
        }
      })
    }

    initAccordions() {
      this.addEventListener('click', (e) => {
        const tab = e.target.closest('.accordion-nav__tab')
        if (!tab) return

        if (tab.classList.contains('accordion-non-active')) return

        const index = tab.getAttribute('data-grid-index')
        if (!index) return

        const panel = this.querySelector(`#animated-accordion-panel-${index}`)
        if (!panel) return

        panel.classList.toggle('accordion-nav__panel--active')
        if (panel.classList.contains('accordion-nav__panel--active')) {
          tab.classList.add('accordion-nav__tab--active')
        } else {
          tab.classList.remove('accordion-nav__tab--active')
        }

        this.setPanelHeight(index)
        // this.closeOtherPanels(tab, index)
      })
    }

    setPanelHeight(index) {
      const panel = this.querySelector(`#animated-accordion-panel-${index}`)
      const children = panel.children

      let panelHeight = 0

      Array.from(children).forEach((child) => {
        panelHeight += child.offsetHeight
      })

      if (!panel) return

      if (panel.classList.contains('accordion-nav__panel--active')) {
        panel.style.setProperty('--panel-height', `${panelHeight}px`)
        panel.querySelectorAll('a').forEach((a) => {
          a.setAttribute('tabindex', '0')
        })
      } else {
        panel.style.setProperty('--panel-height', `0px`)
        panel.querySelectorAll('a').forEach((a) => {
          a.setAttribute('tabindex', '-1')
        })
      }
    }

    closeOtherPanels(currentTab, currentIndex) {
      const tabs = this.querySelectorAll('.accordion-nav__tab')
      tabs.forEach((tab) => {
        if (tab !== currentTab) {
          const index = tab.getAttribute('data-grid-index')
          const panel = this.querySelector(`#animated-accordion-panel-${index}`)

          tab.classList.remove('accordion-nav__tab--active')
          if (panel) {
            panel.classList.remove('accordion-nav__panel--active')
            panel.style.setProperty('--panel-height', `0px`)
          }
        }
      })
    }

    setFirstPanelHeight() {
      const firstPanel = this.querySelector('.accordion-nav__panel')
      if (!firstPanel) return
      const firstPanelHeight = firstPanel.offsetHeight
      firstPanel.style.setProperty('--panel-height', `${firstPanelHeight}px`)
    }

    switchMenu(menuHandle) {
      this.currentMenuHandle = menuHandle

      if (this.menuCache[menuHandle]) {
        const cachedData = this.menuCache[menuHandle]
        this.renderContent(cachedData.transformedData, cachedData.weeklyDeals)
      } else {
        console.warn(`Menu ${menuHandle} not found in cache`)
      }
    }

    getMenuFieldsQuery() {
      return `
        titleField: field(key: "title") {
          value
        }
        tabTextField: field(key: "tab_text") {
          value
        }
        hideFlashDealsBannerField: field(key: "hide_flash_deals_banner") {
          value
        }
        showBannersAsSingleLineGridField: field(key: "show_banners_as_single_line_grid") {
          value
        }
        bannerField: field(key: "banner") {
          reference {
            ... on MediaImage {
              alt
              image {
                url
              }
            }
          }
        }
        bannerTextField: field(key: "banner_text") {
          value
        }
        bannerUrlField: field(key: "banner_link") {
          value
        }
        secondBannerField: field(key: "second_banner") {
          reference {
            ... on MediaImage {
              alt
              image {
                url
              }
            }
          }
        }
        secondBannerTextField: field(key: "second_banner_text") {
          value
        }
        secondBannerUrlField: field(key: "second_banner_link") {
          value
        }
        secondBannerMenuHandleField: field(key: "second_banner_menu_handle") {
          value
        }
        thirdBannerField: field(key: "third_banner") {
          reference {
            ... on MediaImage {
              alt
              image {
                url
              }
            }
          }
        }
        thirdBannerTextField: field(key: "third_banner_text") {
          value
        }
        thirdBannerUrlField: field(key: "third_banner_link") {
          value
        }
        thirdBannerMenuHandleField: field(key: "third_banner_menu_handle") {
          value
        }
        fourthBannerField: field(key: "fourth_banner") {
          reference {
            ... on MediaImage {
              alt
              image {
                url
              }
            }
          }
        }
        fourthBannerTextField: field(key: "fourth_banner_text") {
          value
        }
        fourthBannerUrlField: field(key: "fourth_banner_link") {
          value
        }
        fourthBannerMenuHandleField: field(key: "fourth_banner_menu_handle") {
          value
        }
        categoriesField: field(key: "categories") {
          references(first: 100) {
            edges {
              node {
                ... on Metaobject {
                  nameField: field(key: "category_name") {
                    value
                  }
                  featuredImageField: field(key: "featured_image") {
                    reference {
                      ... on MediaImage {
                        alt
                        image {
                          url
                        }
                      }
                    }
                  }
                  subtextField: field(key: "subtext") {
                    value
                  }
                  urlField: field(key: "url") {
                    value
                  }
                  collectionField: field(key: "collection") {
                    reference {
                      ... on Collection {
                        onlineStoreUrl
                      }
                    }
                  }
                  itemsField: field(key: "menu_items") {
                    references(first: 100) {
                      edges {
                        node {
                          ... on Metaobject {
                            titleField: field(key: "title") {
                              value
                            }
                            imageField: field(key: "image_desktop") {
                              reference {
                                ... on MediaImage {
                                  image {
                                    url
                                  }
                                }
                              }
                            }
                            imageForTestingField: field(key: "image_for_testing") {
                              reference {
                                ... on MediaImage {
                                  image {
                                    url
                                  }
                                }
                              }
                            }
                            productField: field(key: "product") {
                              reference {
                                ... on Product {
                                  title
                                  availableForSale
                                  onlineStoreUrl
                                }
                              }
                            }
                            collectionField: field(key: "collection") {
                              reference {
                                ... on Collection {
                                  onlineStoreUrl
                                  firstAvailableProduct: products(first: 1, filters: { available: true }) {
                                    edges {
                                      node {
                                        onlineStoreUrl
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            useCollectionUrlField: field(key: "use_collection_url") {
                              value
                            }
                            showNewArrivalBadgeField: field(key: "show_new_arrival_badge") {
                              value
                            }
                            showNewArrivalBadgeDateField: field(key: "new_arrival_badge_end_date") {
                              value
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        tile1ImageField: field(key: "tile_1_image") {
          reference {
            ... on MediaImage {
              image {
                url
              }
            }
          }
        }
        tile2ImageField: field(key: "tile_2_image") {
          reference {
            ... on MediaImage {
              image {
                url
              }
            }
          }
        }
        tile1TextField: field(key: "tile_1_text") {
          value
        }
        tile2TextField: field(key: "tile_2_text") {
          value
        }
        tile1PathField: field(key: "tile_1_path") {
          value
        }
        tile2PathField: field(key: "tile_2_path") {
          value
        }
        textLinksField: field(key: "text_links") {
          references(first: 10) {
            edges {
              node {
                ... on Metaobject {
                  textField: field(key: "text") {
                    value
                  }
                  pathField: field(key: "path") {
                    value
                  }
                }
              }
            }
          }
        }
      `
    }

    transformWeeklyDealsData(fields) {
      const data = {
        start_date: null,
        end_date: null,
        quantity_left: null,
        mobile_nav_banner_src: null,
        is_active: false,
      }

      fields.forEach((field) => {
        switch (field.key) {
          case 'start_date':
            data.start_date = field.value
            break
          case 'end_date':
            data.end_date = field.value
            break
          case 'quantity_left':
            data.quantity_left = parseInt(field.value)
            break
          case 'mobile_nav_banner':
            data.mobile_nav_banner_src = field.reference?.image?.url || null
            break
        }
      })

      if (data.start_date && data.end_date && data.quantity_left) {
        const now = new Date()
        const startDate = new Date(data.start_date)
        const endDate = new Date(data.end_date)

        if (now >= startDate && now <= endDate && data.quantity_left > 0) data.is_active = true
      }

      return data
    }

    async fetchWeeklyDeals() {
      try {
        const query = `
            query WeeklyDeals @inContext(country: ${this.dataset.country.toUpperCase()}, language: ${this.dataset.locale.toUpperCase()}) {
              metaobject(handle: {handle: "${this.weeklyDeal}", type: "lightning_deals"}) {
                fields {
                  key
                  value
                  reference {
                    ... on MediaImage {
                      image {
                        url
                      }
                    }
                  }
                }
              }
            }
          `
        const endpoint = '/api/2025-07/graphql.json'
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'b7cddfa2ac815edc1ce3062ba667fe38',
          },
          body: JSON.stringify({ query }),
        })
        const data = await response.json()
        const weeklyDealsData = this.transformWeeklyDealsData(data.data.metaobject.fields)
        return weeklyDealsData
      } catch (error) {
        console.error('Error fetching weekly deals:', error)
        return null
      }
    }

    async fetchAllMenus() {
      this.abortController?.abort()
      this.abortController = new AbortController()

      this.classList.add('loading')

      const allMenuHandlesAttr = this.dataset.allMenuHandles
      if (!allMenuHandlesAttr) {
        console.warn('No menu handles provided')
        return
      }

      const allMenuHandles = allMenuHandlesAttr.split(',').map((h) => h.trim())
      const weeklyDeals = await this.fetchWeeklyDeals()
      const menuFields = this.getMenuFieldsQuery()

      const queries = allMenuHandles.map(
        (handle) => `
        ${handle.replace(/-/g, '_')}: metaobject(handle: {handle: "${handle}", type: "menu"}) {
          ${menuFields}
        }
      `,
      )

      const query = `
        query MultipleMenus @inContext(country: ${this.dataset.country.toUpperCase()}, language: ${this.dataset.locale.toUpperCase()}) {
          ${queries.join('\n')}
        }
      `

      const endpoint = '/api/2025-07/graphql.json'

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'b7cddfa2ac815edc1ce3062ba667fe38',
          },
          body: JSON.stringify({ query }),
          signal: this.abortController.signal,
        })

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

        const data = await response.json()

        if (data.errors) {
          console.error('GraphQL errors:', data.errors)
        } else {
          // Cache all menus
          allMenuHandles.forEach((handle) => {
            const aliasKey = handle.replace(/-/g, '_')
            if (data.data[aliasKey]) {
              const transformedData = this.transformMenuData(data.data[aliasKey])
              this.menuCache[handle] = {
                transformedData,
                weeklyDeals,
              }
            }
          })

          // Render the current menu
          if (this.menuCache[this.currentMenuHandle]) {
            const cachedData = this.menuCache[this.currentMenuHandle]
            this.renderContent(cachedData.transformedData, cachedData.weeklyDeals)
            this.classList.remove('loading')
            this.setFirstPanelHeight()
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          this.classList.remove('loading')
        } else {
          console.error('Error fetching all menus:', error)
          this.classList.remove('loading')
        }
      }
    }

    async fetchMenu() {
      this.abortController?.abort()
      this.abortController = new AbortController()

      this.classList.add('loading')
      this.menuHandle = this.getAttribute('data-menu-handle')

      const query = `
          query MobileNav @inContext(country: ${this.dataset.country.toUpperCase()}, language: ${this.dataset.locale.toUpperCase()}) {
            metaobject(handle: {handle: "${this.menuHandle}", type: "menu"}) {
              ${this.getMenuFieldsQuery()}
            }
          }
        `

      const endpoint = '/api/2025-07/graphql.json'

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'b7cddfa2ac815edc1ce3062ba667fe38',
          },
          body: JSON.stringify({ query }),
          signal: this.abortController.signal,
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()

        if (data.errors) {
          console.error('GraphQL errors:', data.errors)
        } else {
          const weeklyDeals = await this.fetchWeeklyDeals()
          const transformedData = this.transformMenuData(data.data.metaobject)
          this.renderContent(transformedData, weeklyDeals)
          this.classList.remove('loading')
          this.setFirstPanelHeight()
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          this.classList.remove('loading')
        } else {
          console.error('Error:', error)
        }
      }
    }

    transformMenuData(menuData) {
      const menuTitle = menuData.titleField?.value || null
      const hideFlashDealsBanner =
        menuData.hideFlashDealsBannerField?.value === 'true' ? true : false
      const showBannersAsSingleLineGrid =
        menuData.showBannersAsSingleLineGridField?.value === 'true' ? true : false
      // Transform banner
      const bannerBlocks = [
        {
          banner: menuData.bannerField?.reference || null,
          bannerUrl: menuData.bannerUrlField?.value || null,
          menuHandle: menuData.bannerMenuHandleField?.value || null,
          text: menuData.bannerTextField?.value || null,
        },
        {
          banner: menuData.secondBannerField?.reference || null,
          bannerUrl: menuData.secondBannerUrlField?.value || null,
          menuHandle: menuData.secondBannerMenuHandleField?.value || null,
          text: menuData.secondBannerTextField?.value || null,
        },
        {
          banner: menuData.thirdBannerField?.reference || null,
          bannerUrl: menuData.thirdBannerUrlField?.value || null,
          menuHandle: menuData.thirdBannerMenuHandleField?.value || null,
          text: menuData.thirdBannerTextField?.value || null,
        },
        {
          banner: menuData.fourthBannerField?.reference || null,
          bannerUrl: menuData.fourthBannerUrlField?.value || null,
          menuHandle: menuData.fourthBannerMenuHandleField?.value || null,
          text: menuData.fourthBannerTextField?.value || null,
        },
      ]

      const categories =
        menuData.categoriesField?.references?.edges?.map(({ node }) => ({
          name: node.nameField?.value || null,
          subtext: node.subtextField?.value || null,
          featuredImage: node.featuredImageField?.reference || null,
          url: node.urlField?.value || null,
          collectionUrl: node.collectionField?.reference?.onlineStoreUrl || null,
          items:
            node.itemsField?.references?.edges
              ?.map(({ node }) => ({
                title: node.titleField?.value || null,
                image: node.imageField?.reference?.image?.url || null,
                image_for_testing:
                  node.imageForTestingField?.reference?.image?.url ||
                  node.imageField?.reference?.image?.url ||
                  null,
                productUrl: node.productField?.reference?.availableForSale
                  ? node.productField?.reference?.onlineStoreUrl
                  : null,
                firstAvailableProductUrl:
                  node.useCollectionUrlField?.value === 'true'
                    ? node.collectionField?.reference?.onlineStoreUrl
                    : node.collectionField?.reference?.firstAvailableProduct?.edges[0]?.node
                        ?.onlineStoreUrl || null,
                showNewArrivalBadgeField:
                  node.showNewArrivalBadgeField?.value === 'true' ? true : false,
                showNewArrivalBadgeDateField:
                  new Date(node.showNewArrivalBadgeDateField?.value).getTime() || 0,
              }))
              ?.filter((item) => item.title) || [],
        })) || []

      // Transform tiles
      const tiles = []
      if (menuData.tile1ImageField?.reference) {
        tiles.push({
          image: menuData.tile1ImageField.reference.image.url,
          text: menuData.tile1TextField?.value || '',
          path: menuData.tile1PathField?.value || '#',
        })
      }
      if (menuData.tile2ImageField?.reference) {
        tiles.push({
          image: menuData.tile2ImageField.reference.image.url,
          text: menuData.tile2TextField?.value || '',
          path: menuData.tile2PathField?.value || '#',
        })
      }

      // Transform text links
      const textLinks =
        menuData.textLinksField?.references?.edges?.map(({ node }) => ({
          text: node.textField?.value || '',
          path: node.pathField?.value || '#',
        })) || []

      return {
        menuTitle,
        hideFlashDealsBanner,
        showBannersAsSingleLineGrid,
        bannerBlocks,
        categories,
        tiles,
        textLinks,
      }
    }

    handleize(string) {
      return string
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '')
    }

    getMobileNavImgTilesTest(menuTitle, categoryName) {
      const template = document.querySelector(
        `template[data-menu-title="${menuTitle}"][data-menu-category="${categoryName}"]`,
      )
      return template ? template.innerHTML : ''
    }

    renderContent(transformedData, weeklyDeals) {
      if (!transformedData) return

      const currentTimestamp = Date.now()
      const showWeeklyDealsBanner = weeklyDeals?.is_active

      let html = ``
      let bannerBlocksHTML = ``
      let bannerBlocksHTML2 = ``

      if (showWeeklyDealsBanner) {
        const diffSeconds = (this.weeklyDealEndDate * 1000 - currentTimestamp) / 1000
        const diffHours = diffSeconds / 3600
        const dealTitle = this.dataset.activePromoName
          ? `${this.dataset.activePromoName} Flash Deals`
          : 'Flash Deals'
        const dealHoursThreshold = 48
        bannerBlocksHTML += `
          <div class="weekly-deals-banner-mobile-nav ${
            transformedData.hideFlashDealsBanner ? 'visually-hidden' : ''
          }">
            <a class="red" href="${this.urlPrefix}/pages/weekly-deals"${diffHours > dealHoursThreshold ? ' style="gap: 0;"' : ''}>
              <span class="mobile-nav__banner-block__text" ${diffHours > dealHoursThreshold ? ' style="font-size: 20px;"' : ''}>${dealTitle}</span>
              ${
                diffHours > dealHoursThreshold
                  ? `
                      <small>Deals ending soon</small>
                    `
                  : `
                <countdown-timer
                  data-timestamp="${this.weeklyDealEndDate * 1000}"
                  data-text-before=""
                  data-is-block-timer="true"
                  style="${diffHours > dealHoursThreshold ? 'display: none;' : ''}"
                >
                </countdown-timer>
              `
              }

            </a>
          </div>
        `
      }

      // Upper banner blocks
      const bannerBlock = transformedData.bannerBlocks[0]
      if (bannerBlock.banner) {
        const bannerBlockContent = `
          ${
            bannerBlock.text
              ? `<span class="mobile-nav__banner-block__text" style="color: #C42F41;font-size: 20px;">${bannerBlock.text}</span>`
              : ``
          }
        `
        bannerBlocksHTML += `
          <div class="" data-block-handle="${bannerBlock.text}">
            ${
              bannerBlock.bannerUrl
                ? `
                    <a class="blue" href="${this.urlPrefix}${bannerBlock.bannerUrl}" >
                      ${bannerBlockContent}${bannerBlockContent.toLowerCase().includes('clearance') ? '<small>While supplies last</small>' : ''}
                    </a>
                  `
                : `
                ${
                  bannerBlock.menuHandle
                    ? `
                        <button type="button" class="mobile-nav-banner-button" data-change-menu-handle="${bannerBlock.menuHandle}" aria-label="Boys menu">
                          ${bannerBlockContent}
                        </button>
                      `
                    : `${bannerBlockContent}`
                }`
            }
          </div>
        `
      }

      // Lower banner blocks
      if (bannerBlocksHTML) {
        html += `<div class="mobile-nav__banner-blocks" ${transformedData.hideFlashDealsBanner ? 'style="display: none;"' : ''}>${bannerBlocksHTML}</div>`
      }

      for (let i = 1; i < transformedData.bannerBlocks.length; i++) {
        const bannerBlock = transformedData.bannerBlocks[i]
        if (!bannerBlock.banner) continue
        const bannerBlockContent = `
          ${
            bannerBlock.text
              ? `<span class="mobile-nav__banner-block__text">${bannerBlock.text}</span>`
              : ``
          }
        `
        bannerBlocksHTML2 += `
          <div class="" data-block-handle="${bannerBlock.text}">
            ${
              bannerBlock.bannerUrl
                ? `
                    <a class="${i === 1 ? 'yellow' : 'blue'}" href="${this.urlPrefix}${bannerBlock.bannerUrl}" >
                      ${bannerBlockContent}
                    </a>
                  `
                : `
                ${
                  bannerBlock.menuHandle
                    ? `
                        <button type="button" class="mobile-nav-banner-button" data-change-menu-handle="${bannerBlock.menuHandle}" aria-label="Boys menu">
                          ${bannerBlockContent}
                        </button>
                      `
                    : `${bannerBlockContent}`
                }`
            }
          </div>
        `
      }

      if (transformedData.categories) {
        const menuTitle = transformedData.menuTitle
        transformedData.categories.forEach((category, index) => {
          index = index + 1
          const { name, items, subtext, featuredImage, collectionUrl } = category
          const mobileNavImgTiles = items
            .map(
              (item, index) =>
                `${
                  item.productUrl !== null || item.firstAvailableProductUrl !== null
                    ? `<li data-style="${item.title}">
                        <a href="${item.productUrl || item.firstAvailableProductUrl || '#'}"
                          aria-label="${item.title}"
                          class="mobile-nav-img-tile__anchor grid-tile__anchor"
                          data-grid-cat=""
                          data-handle="${item.productHandle}"
                          id="animated-accordion-tab-${index}"
                          tabindex="-1"
                        >
                          <div class="mobile-nav-img-tile__wrapper">
                            <div class="mobile-nav-img-tile__img-wrapper">
                              <img src="${
                                item.image
                              }&width=200" class="motion-reduce mobile-nav-img-tile__img ${
                                item.image_for_testing ? 'nav-menu-image-for-testing_a' : ''
                              }" loading="lazy" height="165" width="132" alt="">
                              ${
                                item.image_for_testing
                                  ? `<img src="${item.image_for_testing}&width=200" class="motion-reduce mobile-nav-img-tile__img nav-menu-image-for-testing_b" loading="lazy" height="165" width="132" alt="" style="display: none;">`
                                  : ''
                              }
                            </div>
                            <div class="mobile-nav-img-tile__text-wrapper">
                              <p class="mobile-nav-img-tile__text">
                                ${item.title}
                              </p>
                            </div>
                          </div>
                        </a>
                        ${
                          item.showNewArrivalBadgeField &&
                          item.showNewArrivalBadgeDateField > currentTimestamp
                            ? `<div class="rebuilt-product-card__badge top-left">
                          <span>New</span>
                        </div>`
                            : ''
                        }
                      </li>`
                    : ``
                }`,
            )
            .join('')

          // console.log('transformedData', transformedData, 'category.name', category.name)
          const mobileNavImgTilesTest = this.getMobileNavImgTilesTest(
            transformedData.menuTitle,
            category.name,
          )
          if (mobileNavImgTiles !== '') {
            html += `
              <div class="accordion-nav__tab__wrapper">
                <button
                  data-grid-index="${index}"
                  data-grid-cat="${this.handleize(name)}"
                  data-handle="${this.handleize(name)}"
                  class="accordion-nav__tab"
                  id="animated-accordion-tab-${index}"
                  aria-controls="animated-accordion-panel-${index}"
                >
                  <span>
                    <span class="accordion-nav__tab__image">
                      ${
                        featuredImage
                          ? `<img src="${featuredImage.image.url}" alt="${featuredImage.alt}" />`
                          : items[0]?.image
                            ? `<img src="${items[0]?.image}" alt="" />`
                            : `<span></span>`
                      }
                    </span>
                    <span class="accordion-nav__tab__content">
                      <span>${name}</span>
                      ${
                        subtext ? `<span class="accordion-nav__tab__subtext">${subtext}</span>` : ``
                      }
                    </span>
                  </span>
                  <span class="accordion-nav__icon addButton"></span>
                  <div class="accordion-nav__icon--chevron"><svg height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg" class="svg-icon svg-icon--chevron-down"><path d="M24 32a2 2 0 0 1-1.41-.59l-12-12a2 2 0 0 1 2.82-2.82L24 27.17l10.59-10.58a2 2 0 0 1 2.82 2.82l-12 12A2 2 0 0 1 24 32z"></path></svg></div>
                </button>
                <a class="accordion-nav__tab__link" data-menu-title="${menuTitle}" href="${collectionUrl}"></a>
              </div>
                <div
                  data-grid-index="${index}"
                  class="accordion-nav__panel scrollbar__thin"
                  id="animated-accordion-panel-${index}"
                  aria-labelledby="animated-accordion-tab-${index}"
                  style="--panel-height: 0px;"
                >
                  <div class="accordion-nav__content">
                    <ul class="mobile-nav__img-tiles">
                      ${mobileNavImgTiles}
                      ${mobileNavImgTilesTest}
                    </ul>
                  </div>
                </div>
              `
          }
        })
      }

      if (bannerBlocksHTML2) {
        html += `<div class="mobile-nav__banner-blocks">${bannerBlocksHTML2}</div>`
      }

      this.content.innerHTML = html

      // Render featured tiles and text links after mobile-nav-categories
      this.renderFeaturedTiles(transformedData.tiles, transformedData.textLinks)
    }

    renderFeaturedTiles(tiles, textLinks) {
      // Remove existing featured tiles and text links if any
      let nextEl = this.nextElementSibling
      while (
        nextEl &&
        (nextEl.classList.contains('mobile-nav-grid') || nextEl.id === 'mobile-navs')
      ) {
        const toRemove = nextEl
        nextEl = nextEl.nextElementSibling
        toRemove.remove()
      }

      let allHTML = ''

      if (tiles && tiles.length > 0) {
        let tilesHTML = `<div class="mobile-nav-grid featured-tiles"><ul class="mobile-nav__img-tiles-featured">`

        tiles.forEach((tile) => {
          tilesHTML += `
              <li class="mobile-nav-featured-tile" data-menu="mobile-nav">
                <a
                  href="${this.urlPrefix}${tile.path}"
                  aria-label="${tile.text}"
                  class="mobile-nav-img-tile__anchor grid-tile__anchor"
                  data-nav-type="featured"
                  data-grid-cat="false"
                  data-handle=""
                >
                  <div class="mobile-nav-img-tile__wrapper">
                    <div class="mobile-nav-img-tile__img-wrapper">
                      <img
                        src="${tile.image}&width=300"
                        srcset="${tile.image}&width=300 1x, ${tile.image}&width=600 2x"
                        alt=""
                        class="motion-reduce mobile-nav-img-tile__img"
                        loading="lazy"
                        height="140"
                        width="auto"
                      />
                    </div>
                    <div class="mobile-nav-img-tile__text-wrapper">
                      <p class="mobile-nav-img-tile__text">${tile.text}</p>
                    </div>
                  </div>
                </a>
              </li>
            `
        })

        tilesHTML += `</ul></div>`
        allHTML += tilesHTML
      }

      if (textLinks && textLinks.length > 0) {
        let textLinksHTML = `
            <nav id="mobile-navs" class="mobile-nav__main-nav bold">
              <div class="nav-item-list-container">
                <ul class="list-unstyled">
          `

        textLinks.forEach((link) => {
          const handle = this.handleize(link.text)
          textLinksHTML += `
              <li data-handle="${handle}" class="nav-item nav-item--${handle} nav-item--main">
                <a
                  href="${this.urlPrefix}/${link.path}"
                  class="nav-link link-is-current-page--false"
                  title="${link.text}"
                >
                  ${link.text}
                </a>
              </li>
            `
        })

        textLinksHTML += `
                </ul>
              </div>
            </nav>
          `
        allHTML += textLinksHTML
      }

      if (allHTML) {
        this.insertAdjacentHTML('afterend', allHTML)
      }

      const changeMenuButton = this.content.querySelector('[data-change-menu-handle]')
      if (changeMenuButton) {
        changeMenuButton.addEventListener('click', (event) => {
          event.preventDefault()
          const newHandle = changeMenuButton.dataset.changeMenuHandle
          if (!newHandle) return

          // Update content to new menu
          this.setAttribute('data-menu-handle', newHandle)
          this.switchMenu(newHandle)

          // Sync UI of the type selector if present
          const selectorRadio = document.querySelector(
            `mobile-nav-type-selector input[value="${newHandle}"]`,
          )
          if (selectorRadio) {
            selectorRadio.checked = true
          }
        })
      }
    }
  }
  customElements.define('mobile-nav-categories', MobileNavCategories)

  const primaryNavToggle = document.querySelector('#primary-nav-toggle')
  if (primaryNavToggle !== null) {
    primaryNavToggle.addEventListener('click', (evt) => {
      if (typeof window.test_menu === 'undefined') {
        window.igEvents = window.igEvents || []
        window.igEvents.push({ event: 'Menu Test - Fallback' })
      }
    })
  }
}
